export default __webpack_public_path__ + "static/media/img-16.f7e53c1f.jpeg";